// Function to open the Balikovna branch selection iframe
function openBalikovnaBranchSelection() {
  const balikovnaContainer = document.createElement('div');
  balikovnaContainer.classList.add('balikovna_pickup-container');

  balikovnaContainer.innerHTML = `
    <div style="height: 35px; display: flex; flex-direction: row; justify-content: flex-end">
      <div style="width: 20px; height: 20px; margin-right: 10px; cursor: pointer;" onclick="closeBalikovnaBranchSelection()">
        <svg viewBox="0 0 26 26" fill="none">
          <path d="M23.4094 1.22941C23.7636 0.88159 24.3312 0.88159 24.6855 1.22941C25.0491 1.58639 25.0491 2.17221 24.6855 2.52919L2.58549 24.2269C2.23122 24.5747 1.66364 24.5747 1.30937 24.2269C0.945776 23.8699 0.945776 23.284 1.30937 22.9271L23.4094 1.22941Z" fill="currentColor"></path>
          <path d="M0.661939 1.89106C0.298343 1.53409 0.298345 0.948263 0.661941 0.591286C1.01621 0.243465 1.58379 0.243466 1.93806 0.591286L25.3381 23.5653C25.7017 23.9223 25.7017 24.5081 25.3381 24.8651C24.9838 25.2129 24.4162 25.2129 24.0619 24.8651L0.661939 1.89106Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
    <div style="height: 100%;">
      <iframe id="balikovnaIframe" title="Výběr místa pro vyzvednutí zásilky" src="https://b2c.cpost.cz/locations/?type=BALIKOVNY" allow="geolocation" style="width: 100%; height: 100%; border: none; border-radius: 20px;"></iframe>
    </div>
  `;

  document.body.appendChild(balikovnaContainer);
}

// Function to close the Balikovna branch selection iframe
function closeBalikovnaBranchSelection() {
  const balikovnaContainer = document.querySelector('.balikovna_pickup-container');
  if (balikovnaContainer) {
    balikovnaContainer.remove();
  }
}

// Function to handle messages from the Balikovna iframe
function iframeListener(event) {
  // Check if the event data has the expected 'message' value
  if (event.data.message === 'pickerResult') {
    resetBranchPlaceholders();
    
    pointId = event.data.point.id;
    
    // Remove leading "B" if it exists
    if (pointId.startsWith('B')) {
      pointId = pointId.substring(1);
    }
    
    pointName = event.data.point.name;
    closeBalikovnaBranchSelection();
    updateBalikovnaBranch(pointName);
  }
}

// Set up the listener on window to handle messages from iframe
window.addEventListener('message', iframeListener);

